var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsistencyPrinciple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.7646,
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0.764648,
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20.7646,
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsistencyPrinciple);
export default __webpack_public_path__ + "static/media/consistency-principle.9dd235cb4d4dc47fb266c5a5c68dbe35.svg";
export { ForwardRef as ReactComponent };